module.exports = __webpack_public_path__ + "static/img/yu.2c5cf6f.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/yu.gif
// module id = /RV+
// module chunks = 5